module.exports = __webpack_public_path__ + "img/warning.f6d65347.png";